import { memo } from 'react'
import Modal from 'react-bootstrap/Modal';

const BzModalFooter = ({ className, ...props }) => {
    return (
        <Modal.Footer  {...props} className={className}>
            {props.children}
        </Modal.Footer>
    )
}

export default memo(BzModalFooter)